/**
 * Country name → flag emoji.
 *
 * Directory country values are free-text names (from CSV import / Apollo),
 * so we map common English names + frequent variants to ISO-3166 alpha-2,
 * then build the regional-indicator emoji. Unknown names return ''.
 */

const NAME_TO_ISO2 = {
  'afghanistan': 'AF', 'albania': 'AL', 'algeria': 'DZ', 'angola': 'AO',
  'argentina': 'AR', 'armenia': 'AM', 'australia': 'AU', 'austria': 'AT',
  'azerbaijan': 'AZ', 'bahrain': 'BH', 'bangladesh': 'BD', 'belarus': 'BY',
  'belgium': 'BE', 'benin': 'BJ', 'bolivia': 'BO', 'bosnia and herzegovina': 'BA',
  'botswana': 'BW', 'brazil': 'BR', 'bulgaria': 'BG', 'burkina faso': 'BF',
  'cambodia': 'KH', 'cameroon': 'CM', 'canada': 'CA', 'chile': 'CL',
  'china': 'CN', 'colombia': 'CO', 'costa rica': 'CR', 'croatia': 'HR',
  'cuba': 'CU', 'cyprus': 'CY', 'czech republic': 'CZ', 'czechia': 'CZ',
  'democratic republic of the congo': 'CD', 'denmark': 'DK', 'dominican republic': 'DO',
  'ecuador': 'EC', 'egypt': 'EG', 'el salvador': 'SV', 'estonia': 'EE',
  'ethiopia': 'ET', 'finland': 'FI', 'france': 'FR', 'georgia': 'GE',
  'germany': 'DE', 'ghana': 'GH', 'greece': 'GR', 'guatemala': 'GT',
  'guinea': 'GN', 'honduras': 'HN', 'hong kong': 'HK', 'hungary': 'HU',
  'iceland': 'IS', 'india': 'IN', 'indonesia': 'ID', 'iran': 'IR',
  'iraq': 'IQ', 'ireland': 'IE', 'israel': 'IL', 'italy': 'IT',
  'ivory coast': 'CI', "cote d'ivoire": 'CI', "côte d'ivoire": 'CI',
  'japan': 'JP', 'jordan': 'JO', 'kazakhstan': 'KZ', 'kenya': 'KE',
  'kuwait': 'KW', 'kyrgyzstan': 'KG', 'laos': 'LA', 'latvia': 'LV',
  'lebanon': 'LB', 'libya': 'LY', 'liechtenstein': 'LI', 'lithuania': 'LT',
  'luxembourg': 'LU', 'macedonia': 'MK', 'north macedonia': 'MK',
  'madagascar': 'MG', 'malawi': 'MW', 'malaysia': 'MY', 'mali': 'ML',
  'malta': 'MT', 'mauritania': 'MR', 'mauritius': 'MU', 'mexico': 'MX',
  'moldova': 'MD', 'monaco': 'MC', 'mongolia': 'MN', 'montenegro': 'ME',
  'morocco': 'MA', 'mozambique': 'MZ', 'myanmar': 'MM', 'namibia': 'NA',
  'nepal': 'NP', 'netherlands': 'NL', 'the netherlands': 'NL',
  'new zealand': 'NZ', 'nicaragua': 'NI', 'niger': 'NE', 'nigeria': 'NG',
  'north korea': 'KP', 'norway': 'NO', 'oman': 'OM', 'pakistan': 'PK',
  'panama': 'PA', 'papua new guinea': 'PG', 'paraguay': 'PY', 'peru': 'PE',
  'philippines': 'PH', 'poland': 'PL', 'portugal': 'PT', 'qatar': 'QA',
  'romania': 'RO', 'russia': 'RU', 'russian federation': 'RU', 'rwanda': 'RW',
  'saudi arabia': 'SA', 'senegal': 'SN', 'serbia': 'RS', 'singapore': 'SG',
  'slovakia': 'SK', 'slovenia': 'SI', 'somalia': 'SO', 'south africa': 'ZA',
  'south korea': 'KR', 'korea': 'KR', 'republic of korea': 'KR',
  'south sudan': 'SS', 'spain': 'ES', 'sri lanka': 'LK', 'sudan': 'SD',
  'sweden': 'SE', 'switzerland': 'CH', 'syria': 'SY', 'taiwan': 'TW',
  'tajikistan': 'TJ', 'tanzania': 'TZ', 'thailand': 'TH', 'togo': 'TG',
  'trinidad and tobago': 'TT', 'tunisia': 'TN', 'turkey': 'TR', 'türkiye': 'TR',
  'turkmenistan': 'TM', 'uae': 'AE', 'united arab emirates': 'AE',
  'uganda': 'UG', 'ukraine': 'UA', 'united kingdom': 'GB', 'uk': 'GB',
  'great britain': 'GB', 'england': 'GB', 'scotland': 'GB',
  'united states': 'US', 'usa': 'US', 'united states of america': 'US',
  'uruguay': 'UY', 'uzbekistan': 'UZ', 'venezuela': 'VE', 'vietnam': 'VN',
  'viet nam': 'VN', 'yemen': 'YE', 'zambia': 'ZM', 'zimbabwe': 'ZW',
};

export const countryToISO2 = (name) => {
  if (!name) return null;
  return NAME_TO_ISO2[String(name).trim().toLowerCase()] || null;
};

export const countryFlag = (name) => {
  const iso = countryToISO2(name);
  if (!iso) return '';
  // Regional indicator symbols: 'A' (65) → U+1F1E6
  return String.fromCodePoint(...[...iso].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
};

export default countryFlag;
